import gravatarUrl from "gravatar-url";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDrag } from "react-dnd";
import { ItemTypes } from "../../utils/ItemTypes";
import deleteIcon from "../../assets/images/delete.png";
import { useDeleteProjectMutation } from "../../features/projects/projectsApi";
import { useSelector } from "react-redux";
import showProjectName from "../../utils/showProjectName";

function ProjectItem({ state, project, projectDelete }) {
    const {
        user: { email },
    } = useSelector((state) => state.auth) || {};

    const [deleteProject, { isSuccess }] = useDeleteProjectMutation();

    const [{ isDragging }, drag] = useDrag({
        type: ItemTypes.TYPE,
        item: {
            project: project,
            stateId: state.id,
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const handleDelete = (e) => {
        e.preventDefault();
        deleteProject(project.id);
        projectDelete(project.id);
    };

    return (
        <div
            ref={drag}
            style={{
                opacity: isDragging ? 0.3 : 1,
                border: project?.filterSelect ? "3px dotted red" : "",
            }}
            className="relative flex flex-col items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100"
            draggable="true"
        >
            {state.id === 1 && project.creator.email === email && (
                <button
                    // onClick={memberAddModalOpen}
                    className="absolute top-0 right-0 flex items-center justify-center hidden w-6 h-6 mt-3 mr-2 text-gray-500 rounded hover:bg-slate-200  hover:text-gray-700 group-hover:flex"
                >
                    <img
                        onClick={handleDelete}
                        src={deleteIcon}
                        alt="delete project"
                        className="w-4 h-4"
                    />
                </button>
            )}
            <span
                style={{
                    background: project.team.color
                        ? project.team.color
                        : "#0cd814",
                }}
                className={`flex items-center h-6 px-3 text-xs font-semibold text-white rounded-full`}
            >
                {project.team.name}
            </span>
            <h4 className="mt-3 text-sm font-medium">
                {showProjectName(project.title)}
            </h4>
            <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                <div className="flex items-center">
                    <svg
                        className="w-4 h-4 text-gray-300 fill-current"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                            clipRule="evenodd"
                        />
                    </svg>
                    <span className="ml-1 leading-none">
                        {moment(project.timestamp).format("MMM d")}
                    </span>
                </div>
                <img
                    className="w-6 h-6 ml-auto rounded-full"
                    src={gravatarUrl(project.creator.email, {
                        size: 80,
                    })}
                    alt={project.creator.email}
                />
            </div>
        </div>
    );
}

export default ProjectItem;
